<app-public-link
  [cssStyles]="cssStyles"
  [isActiveLink]="isActiveLink"
  [isHideStatus]="isHideStatus"
  [url]="userUrl"
  [urlParams]="userUrlParams"
  [text]="text"
  [attr.data-test-id]="dataTestId"
  [needComma]="needComma"
  [status]="status"
  [openInNewWindow]="openInNewWindow"
  (submit)="onSubmit()"
>
</app-public-link>
